// eslint-disable-next-line
import * as linkify from 'linkifyjs';
import linkifyHtml from 'linkify-html';
import moment from 'moment-timezone';
import { isMobile, isTablet } from 'mobile-device-detect';
import {
  GetApiActionWithAuthorization,
  PostApiWithAuthorizationAction
} from "@/helpers/apiActions"

export const common = {
    data() {
      return {
        users: [],
        currentUser: {},
        notificationSuccessSound: null,
        triggerField: false
      }
    },

    mounted() {
      let _vm = this
      _vm.triggerField = true
      _vm.$nextTick(() => {
        if (typeof _vm.$refs.drawerPrimaryField !== 'undefined') {
          _vm.$refs.drawerPrimaryField.focus()
        }
        //
        if (typeof _vm.$refs.drawerDescriptionField !== 'undefined') {
          _vm.$refs.drawerDescriptionField.focus()
        }
        //
        if (typeof _vm.$refs.mbBarcodeField !== 'undefined') {
          _vm.$refs.mbBarcodeField.focus()
        }
      })
      //
      _vm.$root.$on('load-comments', (id) => {
        _vm.loadComments(id).then(data => {
          _vm.comments = data
          let productIndex = _vm.tableData.findIndex(v=>v.id==id)
          _vm.tableData[productIndex].Comments = data
        })
      })
      //
      _vm.notificationSuccessSound = new Audio('/sounds/scan-success.mp3');
      //
      _vm.$root.$on('display-bin-items-drawer', id => {
        _vm.formBinNumber = id
        _vm.displayBinItemPopup = true
      })
      //
      _vm.$root.$on('display-bin-drawer', params => {
        for (const property in params) {
          _vm[property] = params[property]
        }
      })
    },

    computed: {
      smallDrawerSize () {
        return isMobile ? '100%' : isTablet ? '50%' : '30%'
      },
      mediumDrawerSize () {
        return isMobile ? '100%' : isTablet ? '60%' : '45%'
      },
      middleDrawerSize () {
        return isMobile ? '100%' : isTablet ? '80%' : '60%'
      },
      largeDrawerSize () {
        return isMobile ? '100%' : isTablet ? '90%' : '75%'
      },
      defaultPaginationParams () {
        return {
          page: 1,
          pageSize: 50
        }
      },
      loggedUser () {
        return JSON.parse(localStorage.getItem('user'))
      }
    },

    watch: {
      triggerField () {
        const _vm = this
        // eslint-disable-next-line
        // console.log(_vm.$refs.drawerPrimaryField)
        if (_vm.$refs.drawerPrimaryField) {
          _vm.$refs.drawerPrimaryField.focus()
        }
        //
        if (_vm.$refs.drawerDescriptionField) {
          _vm.$refs.drawerDescriptionField.focus()
        }
        //
        if (typeof _vm.$refs.mbBarcodeField !== 'undefined') {
          _vm.$refs.mbBarcodeField.focus()
        }
        _vm.triggerField = false
      }
    },

    methods: {
      /**
       * ================================================
       * BEGIN ALLOW TO DISPLAY BUTTONS FROM ITS STATUSES
       * ================================================
       */
      hasEndListingStatus (status) {
        return ['submitted'].includes(status)
      },
      hasRebuildPictureStatus (status) {
        return ['review', 'flagged'].includes(status)
      },
      hasCallToQueueStatus (status) {
        return ['submitted', 'unpaid'].includes(status)
      },
      hasRelistItemStatus (status) {
        return ['manual', 'unsold'].includes(status)
      },
      hasReviseItemStatus (status) {
        return ['submitted', 'unpaid'].includes(status)
      },
      hasShareToSocialMediaStatus (status) {
        return ['submitted', 'unpaid'].includes(status)
      },
      hasArchiveStatus (status) {
        return [
                'review',
                'flagged', 
                'unsold',
                'queue',
                'identified',
                'identified_with_photo',
                'manual'
              ].includes(status)
      },
      hasForceSubmitStatus (status) {
        return ['flagged', 'queue', 'unsold', 'relist_failed'].includes(status)
      },
      hasSendToFlaggedStatus (status) {
        return ['unsold', 'queue'].includes(status)
      },
      hasSendToRelistStatus (status) {
        return ['sold'].includes(status)
      },
      hasSendToReviewStatus (status) {
        return [
          'identified',
          'identified_with_photo',
          'queue',
          'unpaid',
          'flagged',
          'sold',
          'manual',
          'archived'
        ].includes(status)
      },
      hasPreviewTemplateStatus (status) {
        return ['review', 'ready', 'unsold', 'sold'].includes(status)
      },
      hasReadyRevertStatus (status) {
        return ['ready'].includes(status)
      },
      hasToolsDropdownStatus (status) {
        return ['not_relisted', 'new'].includes(status)
      },
      hasMarkPresetStatus(status) {
        return ['review', 'flagged', 'submitted', 'unpaid', 'sold'].includes(status)
      },
      hasMarkReadStatus(status) {
        return status == 'review'
      },
      /**
       * ================================================
       * END ALLOW TO DISPLAY BUTTONS FROM ITS STATUSES
       * ================================================
       */
      /**
       * ================================================
       * BEGIN EVERY ACTIONS CAN BE PROCESSED ON AN ITEM
       * ================================================
       */
      /**
       * 
       * @param {*} id 
       */
      readyRevert (id) {
        let _vm = this
        return GetApiActionWithAuthorization("admin/products/ready-revert/" + id).then(res => {
          if (res.status == "success") {
            const data = _vm.tableData
            const findIndex = data.findIndex(v=>v.id==id)
            _vm.tableData = data.filter((v, i) => i !== findIndex)
            _vm.updateDomTabCount('ready', 1, false)
            _vm.updateDomTabCount('review');
          }
          return res
        }).catch(error => {
          // eslint-disable-next-line
          console.log(error)
          _vm.$toast.error(error.message, {
            position: "top-right",
            timeout: 1000,
            closeOnClick: true
          });
          return error
        });
      },
      forceSubmit (id) {
        if (confirm('Are you sure that you want to list this item by force ?')) {
          let _vm = this
          _vm.$toast.warning('Force Submitting Product To Ebay...', {
            position: "bottom-right",
            timeout: false,
            closeOnClick: true,
            icon: 'el-icon-loading'
          })
          return PostApiWithAuthorizationAction("admin/products/force-submit-single/" + id).then(res => {
            _vm.$toast.clear()
            if (res.status == "success") {
              const data = _vm.tableData
              const findIndex = data.findIndex(v=>v.id==id)
              _vm.tableData = data.filter((v, i) => i !== findIndex)
              if (typeof _vm.formFilter !== 'undefined') {
                _vm.updateDomTabCount('submitted');
                _vm.updateDomTabCount(_vm.formFilter.tab, 1, false)
              }
              _vm.$toast.success(res.message, {
                position: "top-right",
                timeout: 1000,
                closeOnClick: true
              });
            }
            //
            return res
          }).catch(error => {
            // eslint-disable-next-line
            console.log(error)
            _vm.$toast.clear()
            _vm.$toast.error(error.message, {
              position: "top-right",
              timeout: 1000,
              closeOnClick: true
            });
            return error
          }).finally(() => {
            _vm.$root.$emit('load-comments', id)
          });
        }
      },
      reviseItem (id) {
        let _vm = this
        _vm.$toast.warning('Updating Product Information in Ebay...', {
          position: "bottom-right",
          timeout: false,
          closeOnClick: true,
          icon: 'el-icon-loading'
        })
        return PostApiWithAuthorizationAction("admin/products/revise-item/" + id).then(res => {
          _vm.$toast.clear()
          if (res.status == "success") {
            _vm.$toast.success(res.message, {
              position: "top-right",
              timeout: 1000,
              closeOnClick: true
            });
          }
          return res
        }).catch(error => {
          // eslint-disable-next-line
          console.log(error)
          _vm.$toast.clear()
          _vm.$toast.error(error.message, {
            position: "top-right",
            timeout: 3000,
            closeOnClick: true
          });
          //
          return error
        })
      },
      callToQueue (id) {
        let _vm = this
        _vm.$toast.warning('Calling back to Queue...', {
          position: "bottom-right",
          timeout: false,
          closeOnClick: true,
          icon: 'el-icon-loading'
        })
        return PostApiWithAuthorizationAction("admin/products/recall-to-queue/" + id).then(res => {
          _vm.$toast.clear()
          if (res.status == "success") {
            const data = _vm.tableData
            const findIndex = data.findIndex(v=>v.id==id)
            _vm.tableData = data.filter((v, i) => i !== findIndex)
            if (typeof _vm.formFilter !== 'undefined') {
              _vm.updateDomTabCount('queue');
              _vm.updateDomTabCount(_vm.formFilter.tab, 1, false)
            }
            _vm.$toast.success(res.message, {
              position: "top-right",
              timeout: 1000,
              closeOnClick: true
            });
          }
          //
          return res
        }).catch(error => {
          // eslint-disable-next-line
          console.log(error)
          _vm.$toast.clear()
          _vm.$toast.error(error.message, {
            position: "top-right",
            timeout: 3000,
            closeOnClick: true
          });
          return error
        })
      },
      endListing (id) {
        if (confirm('Are you sure that you want to end this listing ?')) {
          let _vm = this
          _vm.$toast.warning('Ending Listing...', {
            position: "bottom-right",
            timeout: false,
            closeOnClick: true,
            icon: 'el-icon-loading'
          })
          return PostApiWithAuthorizationAction("admin/products/end-item/" + id).then(res => {
            _vm.$toast.clear()
            if (res.status == "success") {
              const data = _vm.tableData
              const findIndex = data.findIndex(v=>v.id==id)
              _vm.tableData = data.filter((v, i) => i !== findIndex)
              if (typeof _vm.formFilter !== 'undefined') {
                _vm.updateDomTabCount('unsold');
                _vm.updateDomTabCount(_vm.formFilter.tab, 1, false)
              }
              _vm.$toast.success(res.message, {
                position: "top-right",
                timeout: 1000,
                closeOnClick: true
              });
            }
            return res
          }).catch(error => {
            // eslint-disable-next-line
            console.log(error)
            _vm.$toast.clear()
            _vm.$toast.error(error.message, {
              position: "top-right",
              timeout: 3000,
              closeOnClick: true
            });
            //
            return error
          })
        }
      },
      returnItem (id) {
        if (confirm('Are you sure that you want return this item ?')) {
          let _vm = this
          _vm.$toast.warning('Moving this item to review...', {
            position: "bottom-right",
            timeout: false,
            closeOnClick: true,
            icon: 'el-icon-loading'
          })
          return PostApiWithAuthorizationAction("admin/products/return-item/" + id).then(res => {
            _vm.$toast.clear()
            if (res.status == "success") {
              const data = _vm.tableData
              const findIndex = data.findIndex(v=>v.id==id)
              _vm.tableData = data.filter((v, i) => i !== findIndex)
              if (typeof _vm.formFilter !== 'undefined') {
                _vm.updateDomTabCount('review');
                _vm.updateDomTabCount(_vm.formFilter.tab, 1, false)
              }
              _vm.$toast.warning(res.message, {
                position: "top-right",
                timeout: 1000,
                closeOnClick: true
              });
            }
            //
            return res
          }).catch(error => {
            // eslint-disable-next-line
            console.log(error)
            _vm.$toast.clear()
            _vm.$toast.error(error.message, {
              position: "top-right",
              timeout: 1000,
              closeOnClick: true
            });
            //
            return error
          });
        }
      },
      relistItem (id) {
        if (confirm('Are you sure that you want relist this item ?')) {
          let _vm = this
          _vm.$toast.warning('Relisting...', {
            position: "bottom-right",
            timeout: false,
            closeOnClick: true,
            icon: 'el-icon-loading'
          })
          return PostApiWithAuthorizationAction("admin/products/relist-item/" + id).then(res => {
            _vm.$toast.clear()
            if (res.status == "success") {
              const data = _vm.tableData
              const findIndex = data.findIndex(v=>v.id==id)
              _vm.tableData = data.filter((v, i) => i !== findIndex)
              if (typeof _vm.formFilter !== 'undefined') {
                _vm.updateDomTabCount('submitted');
                _vm.updateDomTabCount(_vm.formFilter.tab, 1, false)
              }
              _vm.$toast.warning(res.message, {
                position: "top-right",
                timeout: 1000,
                closeOnClick: true
              });
            }
            //
            return res
          }).catch(error => {
            // eslint-disable-next-line
            console.log(error)
            _vm.$toast.clear()
            _vm.$toast.error(error.message, {
              position: "top-right",
              timeout: 1000,
              closeOnClick: true
            });
            //
            return error
          });
        }
      },
      sendToRelist (id) {
        if (confirm('Are you sure that you want to move this item to relist ?')) {
          let _vm = this
          return GetApiActionWithAuthorization("admin/products/send-to-relist/" + id).then(res => {
            if (res.status == "success") {
              const data = _vm.tableData
              const findIndex = data.findIndex(v=>v.id==id)
              _vm.tableData = data.filter((v, i) => i !== findIndex)
              if (typeof _vm.formFilter !== 'undefined') {
                _vm.updateDomTabCount('unsold');
                _vm.updateDomTabCount(_vm.formFilter.tab, 1, false)
              }
              _vm.$toast.warning(res.message, {
                position: "top-right",
                timeout: 1000,
                closeOnClick: true
              });
            }
            //
            return res
          }).catch(error => {
            // eslint-disable-next-line
            console.log(error)
            _vm.$toast.error(error.message, {
              position: "top-right",
              timeout: 1000,
              closeOnClick: true
            });
            //
            return error
          });
        }
      },
      submitToTimeQueue (id) {
        let _vm = this
        return GetApiActionWithAuthorization("admin/products/submit-time-queue/" + id).then(res => {
          if (res.status == "success") {
            const data = _vm.tableData
            const findIndex = data.findIndex(v=>v.id==id)
            _vm.tableData = data.filter((v, i) => i !== findIndex)
            if (typeof _vm.formFilter !== 'undefined') {
              _vm.updateDomTabCount('queue');
              _vm.updateDomTabCount(_vm.formFilter.tab, 1, false)
            }
            _vm.$toast.warning(res.message, {
              position: "top-right",
              timeout: 1000,
              closeOnClick: true
            });
          }
          //
          return res
        }).catch(error => {
          // eslint-disable-next-line
          console.log(error)
          _vm.$toast.error(error.message, {
            position: "top-right",
            timeout: 1000,
            closeOnClick: true
          });
          //
          return error
        });
      },
      submitToQueue (id) {
        let _vm = this
        return GetApiActionWithAuthorization("admin/products/submit-single/" + id).then(res => {
          if (res.status == "success") {
            const data = _vm.tableData
            const findIndex = data.findIndex(v=>v.id==id)
            _vm.tableData = data.filter((v, i) => i !== findIndex)
            if (typeof _vm.formFilter !== 'undefined') {
              _vm.updateDomTabCount('queue');
              _vm.updateDomTabCount(_vm.formFilter.tab, 1, false)
            }
            _vm.$toast.warning(res.message, {
              position: "top-right",
              timeout: 1000,
              closeOnClick: true
            });
          }
          //
          return res
        }).catch(error => {
          // eslint-disable-next-line
          console.log(error)
          _vm.$toast.error(error.message, {
            position: "top-right",
            timeout: 1000,
            closeOnClick: true
          });
          //
          return error
        });
      },
      loadPreviewTemplate(id) {
        let _vm = this
        let url = "admin/products/preview-template/" + id
        _vm.selectedAuctionId = id
        let selectedApp = (typeof _vm.selectedPreviewApp == 'object') ? _vm.selectedPreviewApp.value : _vm.selectedPreviewApp
        return GetApiActionWithAuthorization(url + "?appId=" + selectedApp).then(res => {
          _vm.previewTemplateContent = res.content
          // show modal
          _vm.viewPreviewTemplate = true
          return res
        }).catch(error => {
          _vm.$toast.error(error.message, {
            position: "top-right",
            timeout: 1000,
            closeOnClick: true
          });
          //
          return error
        });
      },
      rebuildPictures(auctionId){
        let _vm = this
        _vm.$toast.success('Rebuilding Picture', {
          position: "bottom-right",
          timeout: false,
          closeOnClick: true,
          icon: 'el-icon-loading'
        });
       return GetApiActionWithAuthorization("admin/products/rebuild-pictures/" + auctionId).then(res => {
          if (res.status == "success") {
            const data = _vm.tableData
            const findIndex = data.findIndex(v=>v.id==auctionId)
            _vm.tableData[findIndex].AuctionAttachments = res.pictures
          }
          //
          return res
        }).catch(error => {
          // eslint-disable-next-line
          console.log(error)
          _vm.$toast.error(error.message, {
            position: "top-right",
            timeout: 1000,
            closeOnClick: true
          });
          //
          return error
        }).finally(() => {
          _vm.$toast.clear()
        });
      },
      shareToSocialMedia(id) {
        let _vm = this
        _vm.loadSocialMedias().then(() => {
          return GetApiActionWithAuthorization("admin/products/load-full-single-product-data/" + id).then(res => {
            if(res.status == "success") {
              _vm.productDetail = res.data
              _vm.displayShareSocialMediaPopup = true
            }
            return res
          })
        }).catch(error => {
          // eslint-disable-next-line
          console.log(error)
          _vm.$toast.error(error.message, {
            position: "top-right",
            timeout: 1000,
            closeOnClick: true
          });
          return error
        });
      },
      archiveProduct(auctionId) {
        let _vm = this
        return GetApiActionWithAuthorization("admin/products/archive/" + auctionId).then(res => {
          if (res.status == "success") {
            const data = _vm.tableData
            const findIndex = data.findIndex(v=>v.id==auctionId)
            _vm.tableData = data.filter((v, i) => i !== findIndex)
            if (typeof _vm.formFilter !== 'undefined') {
              _vm.updateDomTabCount('archived');
              _vm.updateDomTabCount(_vm.formFilter.tab, 1, false)
            }
            _vm.$toast.error(res.message, {
              position: "top-right",
              timeout: 1000,
              closeOnClick: true
            });
          }
          //
          return res
        }).catch(error => {
          // eslint-disable-next-line
          console.log(error)
          _vm.$toast.error(error.message, {
            position: "top-right",
            timeout: 1000,
            closeOnClick: true
          });
          //
          return error
        });
      },
      sendToFlagged(auctionId) {
        let _vm = this
        return GetApiActionWithAuthorization("admin/products/send-to-flagged/" + auctionId).then(res => {
          if (res.status == "success") {
            const data = _vm.tableData
            const findIndex = data.findIndex(v=>v.id==auctionId)
            _vm.tableData = data.filter((v, i) => i !== findIndex)
            if (typeof _vm.formFilter !== 'undefined') {
              _vm.updateDomTabCount('flagged');
              _vm.updateDomTabCount(_vm.formFilter.tab, 1, false)
            }
            _vm.$toast.success(res.message, {
              position: "top-right",
              timeout: 1000,
              closeOnClick: true
            });
          }
          //
          return res
        }).catch(error => {
          // eslint-disable-next-line
          console.log(error)
          _vm.$toast.error(error.message, {
            position: "top-right",
            timeout: 1000,
            closeOnClick: true
          });
          //
          return error
        });
      },
      markAsIdentified (auctionId) {
        if (confirm('Are you sure that you want to mark this items as Identified ?')) {
          let _vm = this
          return GetApiActionWithAuthorization("admin/products/send-to-identified/" + auctionId).then(res => {
            if (res.status == "success") {
              const data = _vm.tableData
              const findIndex = data.findIndex(v=>v.id==auctionId)
              _vm.tableData = data.filter((v, i) => i !== findIndex)
              if (typeof _vm.formFilter !== 'undefined') {
                _vm.updateDomTabCount('identified');
                _vm.updateDomTabCount(_vm.formFilter.tab, 1, false)
              }
              _vm.$toast.success(res.message, {
                position: "top-right",
                timeout: 1000,
                closeOnClick: true
              });
            }
            //
            return res
          }).catch(error => {
            // eslint-disable-next-line
            console.log(error)
            _vm.$toast.error(error.message, {
              position: "top-right",
              timeout: 1000,
              closeOnClick: true
            });
            //
            return error
          });
        }
      },
      sendToReview(auctionId) {
        let _vm = this
        return GetApiActionWithAuthorization("admin/products/send-to-review/" + auctionId).then(res => {
          if (res.status == "success") {
            const data = _vm.tableData
            const findIndex = data.findIndex(v=>v.id==auctionId)
            _vm.tableData = data.filter((v, i) => i !== findIndex)
            if (typeof _vm.formFilter !== 'undefined') {
              _vm.updateDomTabCount('review');
              _vm.updateDomTabCount(_vm.formFilter.tab, 1, false)
            }
            _vm.$toast.success(res.message, {
              position: "top-right",
              timeout: 1000,
              closeOnClick: true
            });
          }
          //
          return res
        }).catch(error => {
          // eslint-disable-next-line
          console.log(error)
          _vm.$toast.error(error.message, {
            position: "top-right",
            timeout: 2000,
            closeOnClick: true
          });
          //
          return error
        });
      },
      markReady(auctionId) {
        let _vm = this
        return GetApiActionWithAuthorization("admin/products/mark-as-read/" + auctionId).then(res => {
          if (res.status == "success") {
            const data = _vm.tableData
            const findIndex = data.findIndex(v=>v.id==auctionId)
            _vm.tableData = data.filter((v, i) => i !== findIndex)
            _vm.updateDomTabCount('ready');
            _vm.updateDomTabCount('review', 1, false)
          }
          //
          return res
        }).catch(error => {
          // eslint-disable-next-line
          console.log(error)
          _vm.$toast.error(error.message, {
            position: "top-right",
            timeout: 1000,
            closeOnClick: true
          });
          //
          return error
        });
      },
      makePreset (auctionId) {
        let _vm = this
        return GetApiActionWithAuthorization("admin/products/copy-as-preset/" + auctionId).then(res => {
          if (typeof res.url !== 'undefined') {
            _vm.goToV2Url(res.url);
          }
          return res
        }).catch(error => {
          _vm.$toast.error(error.message, {
            position: "top-right",
            timeout: 1000,
            closeOnClick: true
          });
          //
          return error
        });
      },
      /**
       * ================================================
       * END EVERY ACTIONS CAN BE PROCESSED ON AN ITEM
       * ================================================
       */
      getStatus (status, property) {
        const defaultStatus = {
          color: 'white',
          borderColor: '#909399',
          bgColor: '#909399',
          value: 'unknow',
          text: 'Unknow'
        }
        //
        const allStatus = {
          '-2': {
            color: 'white',
            borderColor: '#5d5d5d',
            bgColor: '#5d5d5d',
            value: 'new',
            text: 'New'
          },
          '-1': {
            color: 'white',
            borderColor: '#909399',
            bgColor: '#909399',
            value: 'identified',
            text: 'Identified'
          },
          '0': {
            color: 'white',
            borderColor: '#909399',
            bgColor: '#909399',
            value: 'identified',
            text: 'Identified'
          },
          '1': {
            color: 'white',
            borderColor: '#409eff',
            bgColor: '#409eff',
            value: 'review',
            text: 'Review'
          },
          '2': {
            color: 'white',
            borderColor: '#e6a23c',
            bgColor: '#e6a23c',
            value: 'flagged',
            text: 'Flagged'
          },
          '3': {
            color: 'white',
            borderColor: '#67c23a',
            bgColor: '#67c23a',
            value: 'submitted',
            text: 'Submitted'
          },
          '4': {
            color: 'white',
            borderColor: '#ffc107',
            bgColor: '#ffc107',
            value: 'queue',
            text: 'Queue'
          },
          '6': {
            color: 'white',
            borderColor: '#08c',
            bgColor: '#08c',
            value: 'sold',
            text: 'Sold'
          },
          '7': {
            color: 'white',
            borderColor: '#444444',
            bgColor: '#444444',
            value: 'unsold',
            text: 'Unsold'
          },
          '8': {
            color: 'white',
            borderColor: '#00796B',
            bgColor: '#00796B',
            value: 'shipped',
            text: 'Shipped'
          },
          '9': {
            color: 'white',
            bgColor: '',
            value: 'ready',
            text: 'Ready'
          },
          '10': {
            color: 'white',
            borderColor: '#f56c6c',
            bgColor: '#f56c6c',
            value: 'archived',
            text: 'Archived'
          },
          '14': {
            color: 'white',
            borderColor: '#ffc107',
            bgColor: '#ffc107',
            value: 'timequeue',
            text: 'TimeQueue'
          },
          '104': {
            color: 'white',
            borderColor: '#888',
            bgColor: '#888',
            value: 'failRelisted',
            text: 'Listing Not found'
          },
        }
        //
        return (typeof allStatus[status] !== 'undefined') ? allStatus[status][property] : defaultStatus[property]
      },
      arraySame (array, target) {
        return target.every(v => array.includes(v))
      },
      playSuccessSound() {
        this.notificationSuccessSound.play()
      },
      formatBinNumber(number) {
        number = (typeof number === 'number') ? number.toString() : number
        return number.padStart(3, '0').replace('000', '...')
      },
      getCommentName(userId) {
        let findUser = Array.isArray(this.users) ? this.users.find(u=>u.id==userId) : false
        return findUser ? findUser.first_name + ' ' + ((findUser.last_name !="") ? findUser.last_name[0] : "") : 'BOT'
      },
      capitalize(string) {
        const arr = string.split(" ");
        //
        for (var i = 0; i < arr.length; i++) {
          arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
        }
        return arr.join(" ");
      },
      linkify(text) {
        return linkifyHtml(text, {
          target: '_blank',
          ignoreTags: [
            "Item.Quantity"
          ],
          nl2br: true,
          truncate: 80
        })
      },
      truncateString(str, num, ellipsis = '...') {
        if (str.length <= num) {
          return str
        }
        // Return str truncated with ellipsis
        return str.slice(0, num) + ellipsis
      },
      nl2br (str, is_xhtml) {
        // http://kevin.vanzonneveld.net
        // +   original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
        // +   improved by: Philip Peterson
        // +   improved by: Onno Marsman
        // +   improved by: Atli Þór
        // +   bugfixed by: Onno Marsman
        // +      input by: Brett Zamir (http://brett-zamir.me)
        // +   bugfixed by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
        // +   improved by: Brett Zamir (http://brett-zamir.me)
        // +   improved by: Maximusya
        // *     example 1: nl2br('Kevin\nvan\nZonneveld');
        // *     returns 1: 'Kevin<br />\nvan<br />\nZonneveld'
        // *     example 2: nl2br("\nOne\nTwo\n\nThree\n", false);
        // *     returns 2: '<br>\nOne<br>\nTwo<br>\n<br>\nThree<br>\n'
        // *     example 3: nl2br("\nOne\nTwo\n\nThree\n", true);
        // *     returns 3: '<br />\nOne<br />\nTwo<br />\n<br />\nThree<br />\n'
        var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br ' + '/>' : '<br>'; // Adjust comment to avoid issue on phpjs.org display
      
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
      },
      goToV1Url(url) {
        window.open(process.env.VUE_APP_CYBERSHOP_V1_URL + url, '_blank');
      },
      goToV2Url(url) {
        window.open(process.env.VUE_APP_URL + url, '_blank');
      },
      loadPageSize() {
        return localStorage.getItem('pageSize') ? localStorage.getItem('pageSize') : 50
      },
      loadComments(auctionId)
      {
        return GetApiActionWithAuthorization("admin/products/get-comments/" + auctionId).then(res => {
          return res.data
        });
      },
      loadProfile () {//move into common mixin
        let _vm = this
        GetApiActionWithAuthorization("admin/auth/profile").then(res => {
          if (res.status == "success") {
            _vm.currentUser = res.data
          }
        }).catch(error => {
          // eslint-disable-next-line
          console.log(error)
          _vm.$toast.error(error.message, {
            position: "top-right",
            timeout: 1000,
            closeOnClick: true
          });
        });
      },
      getFormattedData(timestamp) {
        return moment(timestamp*1000).format('YYYY-MM-DD h:mm a')
      },
      getFormattedDateOnly(timestamp) {
        return moment(timestamp*1000).format('YYYY-MM-DD')
      },
      clearSelection () {
        if (window.getSelection) {
          if (window.getSelection().empty) {  // Chrome
            window.getSelection().empty()
          } else if (window.getSelection().removeAllRanges) {  // Firefox
            window.getSelection().removeAllRanges()
          }
        } else if (document.selection) {  // IE?
          document.selection.empty()
        }
      },
      updateDomTabCount(tab = '', count = 1, increase = true) {
        let total = increase
                    ? parseInt(document.getElementById(tab + '-count').innerText) + count
                    : parseInt(document.getElementById(tab + '-count').innerText) - count;
        document.getElementById(tab + '-count').textContent = total
      },
      getUrlParams (searchParams = null) {
        const parser = new URL(window.location)
        if (!searchParams) {
          searchParams = parser.searchParams
        }
        let params = {}
        for (const [key, value] of searchParams.entries()) {
          params[key] = value
        }
        return params
      },
      getFormattedDateFromFull(date, format = 'YYYY-MM-DD HH:mm:ss') {
        return moment(date).format(format)
      },
      getDateTimeAgo(date) {
        return moment(date).fromNow()
      }
    },
}